import {
    selectDoc,
    event,
    selectArr,
    isVisible,
    addClassAll
} from "../utils/utils";

import {initSlider} from "../helpers/service.slider";

import {QuickView} from "./component.quickview";
import {PCP} from "./component.pcp";
import doCookies from "../lib/docookies.min.js";
import {lazyLoadShow} from "./component.animate";

export const initFCollectionProductCard = (cards = null, slider = true) => {
    addClassAll(selectArr('.fcol-slider'), 'show')
    cards = cards ?? selectArr(`.section-featured-collection .product-card`);
    cards.map(card => {
        let parentClass = ''
        if(slider) {
            parentClass = '.glide__slide:not(.glide__slide--clone) '
            if(card.parentNode.className.includes('glide__slide--clone')) {
                parentClass = '.glide__slide--clone '
            }
        }

        let buttons = selectArr((`${parentClass}#${card.id} .color-variants button:not(.disabled)`));
        buttons.map(btn => {
            event(btn, 'click', function () {
                PCP.switchCardColor(card.id , btn.getAttribute('data-color'))
                $(btn).attr('aria-pressed', 'true');
                $(btn).parent('.color-variants__item').siblings('.color-variants__item').children('button').attr('aria-pressed', 'false');
                $(btn).parent('.color-variants__item').siblings('.color-variants__item').children('label').removeClass('d-block').addClass('d-none');
                $(btn).next().removeClass('d-none').addClass('d-block');

            });
            PCP.switchCardColor(card.id , 'default', false, false)
            if ($(btn).hasClass("active")) {
                $(btn).attr('aria-pressed', 'true');
                $(btn).next().removeClass('d-none').addClass('d-block');
            }
        })
    });
}

export const initNewsletterPopUp = () => {
    let hprops = {
        html: selectDoc('html'),
        newsPop: selectDoc('#newsletter-modal'),
        newsPopModal: selectDoc('#newsletter-modal .modal'),
        newsPopClose: selectArr('#newsletter-modal .close-atc'),
        newsPopDiscount: selectDoc('#newsletter-modal #success #discount-code'),
        newsPopDiscountCopied: selectDoc('#newsletter-modal #success #discount-copied'),
    }

    if(hprops.newsPop) {
        hprops.showCount = 1;
        const checkOutSide = async (e) => {
            if (!hprops.newsPopModal.contains(e.target) && isVisible(hprops.newsPopModal)) {
                if (hprops.showCount > 0) {
                    hprops.showCount = 0;
                    hprops.newsPop.classList.remove('active')
                    hprops.html.classList.remove('noscroll')
                    document.removeEventListener('click', checkOutSide);
                } else {
                    hprops.showCount++;
                }
            }
        };

        /**
         *  Check cookies
         */
        let cookieName = 'wsnewsletter' + window.location.pathname.replaceAll('/', ''),
            cookieVal = doCookies.getItem(cookieName);
        if (cookieVal == 'false' || cookieVal == null) {
            doCookies.setItem(cookieName, 'false');
            hprops.newsPop.classList.add('active')
            hprops.html.classList.add('noscroll')
            selectArr('.lazy-load', hprops.newsPop).map(image => {
                lazyLoadShow(image);
            })
            event(document, 'click', checkOutSide);
        }
        else {
            hprops.newsPop.classList.remove('active')
            hprops.html.classList.remove('noscroll')
            hprops.showCount = 1;
        }

        /**
         * Close actions
         */
        hprops.newsPopClose.map(close => {
            event(close, 'click', function () {
                hprops.newsPop.classList.remove('active')
                hprops.html.classList.remove('noscroll')
                doCookies.setItem(cookieName, 'true');
                hprops.showCount = 1;
            })
        })

        /**
         * Discount copy
         */
        if(hprops.newsPopDiscount) {
            hprops.newsPopDiscountCopied.innerHTML = 'Copy to clipboard.'
            event(hprops.newsPopDiscount, 'click', function () {
                hprops.newsPopDiscount.select();
                hprops.newsPopDiscount.setSelectionRange(0, 99999);
                document.execCommand("copy");
                hprops.newsPopDiscountCopied.innerHTML = 'Copied!'
            })
        }
    }
}

const initializer = () => {
    // @ada
    // QuickView.init();
    $(".product-card .image").each(function(){
        const hoverImage = $(this).find('.content.active').next('.color-img-hover').length;
        $(this).focusin(function () {
            $(this).next('.quickview').css('opacity', '1');
            $(this).find('.content.active').next('.color-img-hover').addClass('with-focus');
            if(hoverImage > 0) {
                $(this).find('.content.active').css('opacity', '0');
            }
        });
        $(this).focusout(function () {
            $(this).find('.content.active').css('opacity', '1');
            $(this).find('.content.active').next('.color-img-hover').removeClass('with-focus');
            $(this).next('.quickview').css('opacity', '0');
        });
    });

    $(".product-card .quickview").each(function(){
        $(this).focusin(function () {
            $(this).css('opacity', '1');
        });
        $(this).focusout(function () {
            $(this).css('opacity', '0');
        });
    });

    selectArr('.products-slider').map(slider => {
        initSlider(`#${slider.id}`, {
            perView: 3,
            type: 'carousel',
            rewind: true,
            bound: true,
            hoverpause: false,
            animationDuration: 1000,
            peek: {
                before: 0,
                after: 0
            },
            breakpoints: {
                1024: {
                    perView:3
                },
                767: {
                    animationDuration: 500,
                    perView: 1,
                    gap: 10,
                    peek: {
                        before: 0,
                        after: 70
                    }
                }
            }
        }, true);
    });
    initFCollectionProductCard();

    selectArr('.ws-hero-slider').map(heroSlider => {
        let sliders = selectArr(`#${heroSlider.id} .glide__slide`);
        if(sliders.length > 1) {
           const slider = initSlider(`#${heroSlider.id}`, {
                rewind: true,
                type: 'slider',
                focusAt: 'center',
                perView: 1,
                bound: true,
                autoplay: 5000,
                hoverpause: false,
                gap: 0,
                peek: {
                    before: 0,
                    after: 0
                }
            });

            $(`#${heroSlider.id} [data-hero-playback]`).on('click', function () {
                self = $(this);
                if ( self.hasClass('play') ) {
                    self.removeClass('play').addClass('pause');
                    self.find('[data-hero-play]').removeClass('d-none').addClass('d-block');
                    self.find('[data-hero-pause]').removeClass('d-block').addClass('d-none');
                    slider.pause();
                } else if ( self.hasClass('pause') ) {
                    self.removeClass('pause').addClass('play');
                    self.find('[data-hero-pause]').removeClass('d-none').addClass('d-block');
                    self.find('[data-hero-play]').removeClass('d-block').addClass('d-none');
                    slider.play(5000);
                }
            });

        } else {
            let controls = selectDoc(`#${heroSlider.id} .slider-controls`);
            let controlsButtons = selectDoc(`#${heroSlider.id} .ws-hero-slider__controls`);
            controls.parentNode.removeChild(controls);
            controlsButtons.parentNode.removeChild(controlsButtons);

        }
    })

    initSlider('.services-slider', {
        type: 'carousel',
        focusAt: 'center',
        rewindDuration: 0,
        peek: {
            before: 0,
            after: 0
        }
    });
}

export const Home = {
    init: () => initializer()
}
